import React from 'react'

import { ColumnAdapter, TableAdapter } from '@makyoapp/makyo-common'

import { ColumnOrCustomDd } from './ColumnOrCustomDd'

export function FunctionConditionSelect({
  id,
  colOptions,
  value,
  onChange,
  table,
  excludeColumns,
  toggleClassName,
  includeUnknown,
}: {
  id: string
  colOptions: ColumnAdapter[]
  value?: string | number | boolean
  onChange: (value: string | number | boolean) => void
  table: TableAdapter
  excludeColumns?: string[]
  toggleClassName?: string
  includeUnknown?: boolean
}) {
  return (
    <ColumnOrCustomDd
      inputClassName='dark:hover:bg-slate-800!'
      inputFocusClassName='dark:bg-slate-800!'
      id={id}
      table={table}
      value={{
        isCustom: false,
        value: value || '',
      }}
      options={colOptions}
      onChange={(v) => {
        onChange(v.value ?? '')
      }}
      toggleClassName={toggleClassName}
      excludeColumns={excludeColumns}
      customTypeOnly={false}
      includeUnknown={includeUnknown}
    />
  )
}
